// extracted by mini-css-extract-plugin
var _1 = "_productApprovalTableSearchAndFilterBar-module__content-container";
var _2 = "_productApprovalTableSearchAndFilterBar-module__input";
export { _1 as "content-container", _2 as "input" }
